import axios from 'axios';
import { useEffect } from 'react';
import { useState } from 'react';
import { catalogStore } from '../stores';
import countries from '../utils/countries.json';

const useGeoLocation = () => {
	const { locationInfo, metaDetails, primaryLocation } = catalogStore;

	const [locationData, setLocationData] = useState(
		{ country: locationInfo?.countryCode } || null
	);

	useEffect(() => {
		const locationFn = () => {
			if (locationInfo?.countryCode && primaryLocation) {
				return setLocationData({ country: locationInfo?.countryCode });
			}
			return getLocation();
		};

		locationFn();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [locationInfo, primaryLocation]);

	function getLocation() {
		// Try browser Geolocation API first
		if (navigator.geolocation) {
			navigator.geolocation.getCurrentPosition(
				position => {
					const { latitude, longitude } = position.coords;
					reverseGeocode(latitude, longitude);
				},
				error => {
					// Fallback to currency-based detection
					fallbackLocation();
				}
			);
		} else {
			fallbackLocation();
		}
	}

	async function reverseGeocode(latitude, longitude) {
		try {
			// Using Open Street Map's reverse geocoding (free, no API key needed)
			const res = await axios.get(
				`https://nominatim.openstreetmap.org/reverse?lat=${latitude}&lon=${longitude}&format=json`
			);
			const countryCode = res.data?.address?.country_code?.toUpperCase();

			if (countryCode) {
				setLocationData({ country: countryCode });
				catalogStore.setPrimaryLocation(countryCode);
				return;
			}
		} catch (error) {
			console.error('Reverse geocoding failed:', error);
		}
		fallbackLocation();
	}

	function fallbackLocation() {
		if (metaDetails?.localCurrency) {
			const siteOwnerLocal = countries.filter(
				country => country.currencyCode === metaDetails?.localCurrency
			)[0];
			if (siteOwnerLocal?.countryCode) {
				setLocationData({ country: siteOwnerLocal.countryCode });
				catalogStore.setPrimaryLocation(siteOwnerLocal.countryCode);
				return;
			}
		}

		setLocationData({ country: 'US' });
		catalogStore.setPrimaryLocation('US');
	}

	return {
		// city: locationData?.city,
		country: locationData?.country,
		// ip: locationData?.ip,
		// countryCode: locationData?.countryCode,
		// lat: locationData?.lat,
		// lon: locationData?.lon,
		// region: locationData?.regionName,
		// regionCode: locationData?.region,
		// timezone: locationData?.timezone,
		// zip: locationData?.zip,
	};
};

export default useGeoLocation;
